/*
* 租赁管理
* */
export const LEASEGETPAGE = 'LEASEGETPAGE'
export const LEASEADD = 'LEASEADD'
export const LEASEUPDATE = 'LEASEUPDATEAA'
export const LEASEDELETE = 'LEASEDELETE'



// WEBPACK FOOTER //
// ./src/store/tenancyManage/types.js